import React from "react";
import * as FaIcons from "react-icons/fa";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import * as BiIcons from "react-icons/bi";

export const SidebarData = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <FaIcons.FaHome />,
  },
  {
    title: "Counseling",
    path: "/counseling",
    icon: <FaIcons.FaAccusoft />,
  },
  {
    title: "Manage Accounts",
    path: "/accounts",
    icon: <FaIcons.FaUsersCog />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "View Accounts",
        path: "/accounts/view-accounts",
        icon: <BiIcons.BiUserPin />,
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "Manage Agents",
    path: "/agents",
    icon: <BiIcons.BiStreetView />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Add Agents",
        path: "/agents/add-agent",
        icon: <BiIcons.BiUserPlus />,
        cName: "sub-nav",
      },
      {
        title: "View Agents",
        path: "/agents/view-agents",
        icon: <BiIcons.BiUserPin />,
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "Manage Clients",
    path: "/team",
    icon: <IoIcons.IoMdPeople />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Add Clients",
        path: "/clients/add-client",
        icon: <BiIcons.BiUserPlus />,
        cName: "sub-nav",
      },
      {
        title: "View Clients",
        path: "/clients/view-clients",
        icon: <FaIcons.FaUsers />,
        cName: "sub-nav",
      },
      {
        title: "View External Clients",
        path: `/external-clients/${"total"}`,
        icon: <FaIcons.FaUserAlt />,
        cName: "sub-nav",
      },
      {
        title: "My Clients",
        path: "/clients/my-clients",
        icon: <FaIcons.FaUserFriends />,
        cName: "sub-nav",
      },
      {
        title: "Assign Clients",
        path: "/clients/assign-clients",
        icon: <BiIcons.BiMessageSquareCheck />,
        cName: "sub-nav",
      },
      {
        title: "Follow-ups",
        path: `/view-all-followups/${"all"}`,
        icon: <BiIcons.BiPhoneOutgoing />,
        cName: "sub-nav",
      },
      {
        title: "My Follow-ups",
        path: `/view-all-followups/${"my"}`,
        icon: <BiIcons.BiPhone />,
        cName: "sub-nav",
      },
      {
        title: "View Leads",
        path: "/clients/view-leads",
        icon: <BiIcons.BiShieldQuarter />,
        cName: "sub-nav",
      },
      {
        title: "Reports",
        path: "/clients/reports",
        icon: <BiIcons.BiClipboard />,
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "Manage Applications",
    path: "/messages",
    icon: <FaIcons.FaEnvelopeOpenText />,

    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "My Applications",
        path: "/applications/main-applications",
        icon: <FaIcons.FaEnvelopeOpenText />,
      },
      {
        title: "Assign Applications",
        path: "/applications/assign-applications",
        icon: <FaIcons.FaExchangeAlt />,
      },
    ],
  },
  // {
  //   title: 'Manage Appointments',
  //   path: '/appointments/view-appointments',
  //   icon: <FaIcons.FaRegCalendarAlt/>,
  // },
  {
    title: "Manage Providers",
    path: "/support",
    icon: <FaIcons.FaBoxOpen />,

    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Add Provider",
        path: "/providers/add-provider",
        icon: <FaIcons.FaSynagogue />,
      },
      {
        title: "View Providers",
        path: "/providers/view-providers",
        icon: <FaIcons.FaUniversity />,
      },
      {
        title: "Expiring Providers",
        path: "/providers/expiring-providers",
        icon: <FaIcons.FaHourglassHalf />,
      },
      {
        title: "Provider Insights",
        path: "/providers/provider-insights",
        icon: <FaIcons.FaChartLine />,
      },
      {
        title: "Provider Setting",
        path: "/providers/settings",
        icon: <FaIcons.FaConnectdevelop />,
      },
    ],
  },
  {
    title: "Manage Finance",
    path: "/finance",
    icon: <FaIcons.FaMoneyCheckAlt />,

    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Application Fee Rule",
        path: "/application-fee",
        icon: <FaIcons.FaFileInvoiceDollar />,
      },
      {
        title: "Discount Rule",
        path: "/discount-rule",
        icon: <FaIcons.FaPercent />,
      },
      {
        title: "Health Insurance",
        path: "/health-insurance",
        icon: <FaIcons.FaBookMedical />,
      },
      {
        title: "GST Settings",
        path: "/finance/gst-settings",
        icon: <FaIcons.FaPercentage />,
      },
      {
        title: "Invoice Branding",
        path: "/finance/invoice-branding",
        icon: <FaIcons.FaPalette />,
      },
      {
        title: "Invoices",
        path: "/finance/invoices",
        icon: <FaIcons.FaFileInvoice />,
      },
      {
        title: "Commissions",
        path: "/commissions-invoices",
        icon: <FaIcons.FaDollarSign />,
      },
      {
        title: "Installments",
        path: "/finance/commission-installments",
        icon: <FaIcons.FaCalendarAlt />,
      },
    ],
  },
  {
    title: "Branches",
    path: "/manageBranch",
    icon: <FaIcons.FaCodeBranch />,

    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Assign Branch",
        path: "/manageBranch",
        icon: <FaIcons.FaUserTie />,
      },
      {
        title: "Manage Branches",
        path: "/branches",
        icon: <FaIcons.FaBuilding />,
      },
    ],
  },
  {
    title: "Reporting",
    path: "/reports",
    icon: <FaIcons.FaChartPie />,

    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Tasks Report",
        path: "/daily-reporting",
        icon: <FaIcons.FaChartLine />,
      },

      {
        title: "Leads Report",
        path: "/leads-reporting",
        icon: <FaIcons.FaChartBar />,
      },
      {
        title: "Clients Report",
        path: "/client-signup",
        icon: <FaIcons.FaUserPlus />,
      },
      {
        title: "Invoices Report",
        path: "/invoices-reports",
        icon: <FaIcons.FaChartPie />,
      },
    ],
  },
  {
    title: "HR Management",
    path: "/hr",
    icon: <FaIcons.FaUserSecret />,

    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "Attendance",
        path: "/attendence",
        icon: <FaIcons.FaUserCheck />,
      },
      {
        title: "Manage Leaves",
        path: "/manage-leaves",
        icon: <FaIcons.FaPlaneDeparture />,
      },
      {
        title: "Manage Policies",
        path: "/manage-policies",
        icon: <FaIcons.FaFileContract />,
      },
      {
        title: "Departments",
        path: "/manage-departments",
        icon: <FaIcons.FaBuilding />,
      },
      {
        title: "Teams",
        path: "/manage-teams",
        icon: <FaIcons.FaUser />,
      },
      {
        title: "Notification",
        path: "/manage-notifications",
        icon: <FaIcons.FaStickyNote />,
      },
      {
        title: "Daily Reports",
        path: "/all-reports",
        icon: <FaIcons.FaDrawPolygon />,
      },
      {
        title: "Alerts",
        path: "/create-alerts",
        icon: <FaIcons.FaRegBell />,
      },
    ],
  },
  {
    title: "Leave",
    path: "/leave",
    icon: <FaIcons.FaPlaneDeparture />,
  },
  {
    title: "Manage CheckList",
    path: "/checklist",
    icon: <FaIcons.FaCheckCircle />,
  },
  {
    title: "SOP & Policies",
    path: "/sop-policies",
    icon: <FaIcons.FaClipboardList />,

    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "SOP Categories",
        path: "/sop-policies-categories",
        icon: <FaIcons.FaFolderOpen />,
      },
      {
        title: "Manage SOP",
        path: "/manage-sop-policies",
        icon: <FaIcons.FaTasks />,
      },
      {
        title: "View SOP & Policies",
        path: "/sop-policies",
        icon: <FaIcons.FaFileAlt />,
      },
      {
        title: "Job Descriptions",
        path: "/job-descriptions",
        icon: <FaIcons.FaIdBadge />,
      },
      {
        title: "Employee Contracts",
        path: "/employee-contracts",
        icon: <FaIcons.FaFileContract />,
      },
    ],
  },
  {
    title: "Company Documents",
    path: "/company-forms",
    icon: <FaIcons.FaFileSignature />,

    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: "View documents",
        path: "/company-forms",
        icon: <FaIcons.FaFolderOpen />,
      },
      {
        title: "Upload documents",
        path: "/company-forms/manage",
        icon: <FaIcons.FaTasks />,
      },
      {
        title: "Approve documents",
        path: "/company-forms/approve",
        icon: <FaIcons.FaCheckCircle />,
      },
      {
        title: "Document categories",
        path: "/company-forms/categories",
        icon: <FaIcons.FaTags />,
      },
    ],
  },
  {
    title: "Events",
    path: "/events/main",
    icon: <FaIcons.FaLayerGroup />,
  },
];
